// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__BE2UA","active":"Modal_active__0m-aU","content":"Modal_content__yBmFf"};